import { mapActions, mapGetters, mapMutations } from "vuex";
import questionText from "../../components/question-text/index.vue";

export default {
    name: "graduate-work-question",
    data() {
        return {
            answers: "",
            reInitComponents: false,
        };
    },
    components: {
        questionText,
    },
    created() {
        if (!this.currentItem) {
            this.fetchData({
                courseSlug: this.$route.params.item,
            }).then(() => {
                this.setData();
            });
        } else {
            this.setData();
        }
    },
    computed: {
        ...mapGetters({
            currentItem: "coursesGraduateWork/currentItem",
            isLoading: "coursesGraduateWork/isLoading",
        }),
    },
    methods: {
        ...mapActions({
            fetchData: "coursesGraduateWork/GET_LIST_ITEM",
            complete: "coursesGraduateWork/COMPLETE_TEST",
            startGraduateWork: "coursesGraduateWork/START_TEST",
            fetchCourse: "courses/GET_COURSE_ITEM",
        }),
        ...mapMutations({
            changeHeader: "coursesGraduateWork/CHANGE_HEADER",
            setCurrentQuestion: "coursesGraduateWork/SET_CURRENT_QUESTION",
            setGraduateWorkStatus: "courses/UPDATE_GRADUATE_WORK_STATUS",
        }),
        setData() {
            this.changeHeader({
                show: true,
                title: this.$t("graduateWork"),
            });

            if (this.currentItem.userGraduateWork.data.status === "on_checking") {
                this.$router.push({
                    name: "graduate-work-check",
                    params: {
                        graduateWorkId: this.$route.params.graduateWorkId,
                        item: this.$route.params.item,
                    },
                });
            } else if (
                this.currentItem.userGraduateWork.data.status === "failed" ||
                this.currentItem.userGraduateWork.data.status === "accepted"
            ) {
                this.$router.push({
                    name: "graduate-work-report",
                    params: {
                        graduateWorkId: this.$route.params.graduateWorkId,
                        item: this.$route.params.item,
                    },
                });
            } else {
                this.startGraduateWork({
                    courseSlug: this.$route.params.item,
                })
                    .then(() => {
                        if (this.currentItem.status === "") {
                            this.completeGraduateWork();
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 403) {
                            // explain WHY the user is being redirected instead
                            // of bouncing silently
                            this.$toasted.success(this.$t("hwAlreadySubmitted"));

                            try {
                                this.$router.push({
                                    name: "graduate-work-check",
                                    params: {
                                        graduateWorkId: this.$route.params.graduateWorkId,
                                        item: this.$route.params.item,
                                    },
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    });
            }
        },
        updateQuestions(data) {
            this.answers = data;
        },
        createFormData() {
            const formData = new FormData();
            formData.append("graduateWorkId", this.$route.params.graduateWorkId);

            return formData;
        },
        completeGraduateWork() {
            const formData = new FormData();
            formData.append("courseSlug", this.$route.params.item);
            formData.append("graduateWorkId", this.$route.params.graduateWorkId);
            formData.append("answer", this.answers);
            formData.append("_method", "patch");

            // the submit button sits at the bottom — scroll up right away so
            // the user is not left staring at the footer during the request
            const app = document.querySelector(".app");
            if (app) app.scrollTop = 0;
            window.scrollTo(0, 0);

            this.complete(formData)
                .then((response) => {
                    this.$toasted.success(this.$t("hwSubmitSuccess"));

                    // the response carries the REAL post-submit status — sync it
                    // into the cached course tree so the dashboard updates
                    // instantly, without waiting for the queue
                    this.setGraduateWorkStatus(response.status);

                    // refetch the course tree (bypassing the TTL cache) so the
                    // diploma work status updates on the dashboard without a reload
                    this.fetchCourse({ slug: this.$route.params.item, force: true }).catch(() => {});

                    if (response.status === "accepted" || response.status === "failed") {
                        try {
                            this.$router.push({
                                name: "graduate-work-report",
                                params: {
                                    graduateWorkId: this.$route.params.graduateWorkId,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        try {
                            this.$router.push({
                                name: "graduate-work-check",
                                params: {
                                    graduateWorkId: this.$route.params.graduateWorkId,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        const errors = error.response.data.validation;
                        for (let i in errors) {
                            this.$toasted.error(errors[i]);
                        }
                    } else if (error.response.status === 403) {
                        // already submitted — tell the user and show the status
                        // page instead of a silent dead click
                        this.$toasted.success(this.$t("hwAlreadySubmitted"));

                        try {
                            this.$router.push({
                                name: "graduate-work-check",
                                params: {
                                    graduateWorkId: this.$route.params.graduateWorkId,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        this.$toasted.error(this.$t("hwSubmitFailed"));
                    }
                });
        },
        closeTest() {
            try {
                this.$router.push({
                    name: "courses-main",
                    params: { item: this.$route.params.item },
                });
            } catch (e) {
                console.log(e);
            }
            this.changeHeader({
                show: false,
                title: "",
            });
        },
    },
    destroyed() {
        this.setCurrentQuestion(null);
    },
};
